import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index/Index'
import ProductsN from '@/page/products/ProductsN'
import Contacts from '@/page/contact/Contact'
import Aboutus from '@/page/aboutus/Aboutus'
import OurHistory from '@/page/aboutus/OurHistory'
import FactoryTour from '@/page/aboutus/FactoryTour'
import StartYourProject from '@/page/startYourProject/Index'

Vue.use(Router)

// export default new Router({
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/products',
      name: 'Products',
      component: ProductsN
    },
    {
      path: '/contact',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/aboutus',
      name: 'Aboutus',
      component: Aboutus
    },
    {
      path: '/our-history',
      name: 'OurHistory',
      component: OurHistory
    },
    {
      path: '/factory-tour',
      name: 'FactoryTour',
      component: FactoryTour
    },
    {
      path: '/start-your-project',
      name: 'StartYourProject',
      component: StartYourProject
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === from.path && to.path !== '/') {
    return false
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js